import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { BillingServiceCreditCardSchema } from './billing-service-credit-card.ts'

export const BillingServiceMethodSchema = z.object({
  type: z.string(),
  id: z.string(),
  created: z.number().optional(),
  card: BillingServiceCreditCardSchema.optional(),
  customer: z.string().optional(),
})

export type BillingServiceMethod = ZodInfer<typeof BillingServiceMethodSchema>
